var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E91CBFFA-62A6-4F68-BC55-69F351884DA6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V0.1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Non-existing-user-creation---GMS_MAZ",
    transform: "translate(-2678.000000, -201.000000)",
    fillRule: "nonzero",
    stroke: "#70AD47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-3",
    transform: "translate(2192.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(173.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(314.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 2,
    fill: "#DDF2CE",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-nonBordered",
    transform: "translate(14.634146, 15.853659)",
    strokeLinecap: "round",
    strokeWidth: 4.20000017
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.609756098,
    y1: 11.5853659,
    x2: 7.60909621,
    y2: 17.7333831,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.7317073,
    y1: 0.609756098,
    x2: 7.75450689,
    y2: 17.4840933,
    id: "Line-2-Copy"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.945630dbcc996681814a54b06a5dc4da.svg";
export { ForwardRef as ReactComponent };